import React from 'react';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import { COLOR } from '@src/styles/color';
import { StyledDeleteBtn } from '@src/new-components/DropZone/index.style';
import ImgNoThumbnail from '@src/assets/images/no-thumbnail.jpg';
import {
  StyledPreviewCard,
  StyledPreviewContent,
  StyledPreviewThumb,
  StyledPreviewTitle,
} from './index.style';

/**
 * URL preview card — shown after a successful crawl.
 *
 * @param {{ title, thumbnail }} preview — crawled result.
 * @param {() => void} [onRemove] — remove handler; omit to hide delete button.
 */
const UrlPreviewItem = ({ preview, onRemove }) => {
  if (!preview) return null;

  return (
    <StyledPreviewCard>
      <StyledPreviewContent>
        <StyledPreviewThumb
          src={preview.thumbnail || ImgNoThumbnail}
          alt={preview.title || 'thumbnail'}
        />
        <StyledPreviewTitle
          variant="body-16-regular"
          color={COLOR.darkGray}
          title={preview.title}
        >
          {preview.title}
        </StyledPreviewTitle>
      </StyledPreviewContent>
      {onRemove && (
        <StyledDeleteBtn onClick={onRemove} aria-label="remove preview">
          <DeleteOutlineRoundedIcon />
        </StyledDeleteBtn>
      )}
    </StyledPreviewCard>
  );
};

export default UrlPreviewItem;
